export interface StaffMember {
    uuid: string;
    name: string;
    group: string;
}

export interface RoleConfig {
    name: string;
    color: string;
    order: number;
}

export const ROLE_CONFIG: Record<string, RoleConfig> = {
    "admin": {
        name: "Admin",
        color: "#dc2626", // red-600
        order: 1
    },
    "developer": {
        name: "Developer",
        color: "#f97316", // orange-500
        order: 2
    },
    "manager": {
        name: "Manager",
        color: "#2563eb", // blue-600
        order: 3
    },
    "head-helper": {
        name: "Head Helper",
        color: "#15803d", // green-700 (darker green)
        order: 4
    },
    "helper": {
        name: "Helper",
        color: "#16a34a", // green-600
        order: 5
    },
    "trial-helper": {
        name: "Trial Helper",
        color: "#6b7280", // gray-500
        order: 6
    },
    "head-architect": {
        name: "Head Architect",
        color: "#7c3aed", // violet-700 (darker purple)
        order: 7
    },
    "architect": {
        name: "Architect",
        color: "#a855f7", // purple-500
        order: 8
    },
    "trial-architect": {
        name: "Trial Architect",
        color: "#6b7280", // gray-500
        order: 9
    },
};
